// #region imports

// --- HS Code
import { AddCommand } from "../shared/add-command";
import { RespondentModel } from "./respondent-model";

// #endregion

export class RespondentAddCommand extends AddCommand<RespondentModel> {
  constructor(
    target: RespondentModel,
    commandId: number,
    identifier: string
  ) {
    super(target, commandId, identifier);
  }
}
